module.exports = __webpack_public_path__ + "static/media/C1.19616c0b.jpg";